module.exports = {
    path: '/model-runtime',
    component: () => import('@/modules/model-runtime/ModelRuntime.vue'),
    meta: { module: 'mr' },
    children: [
        {
            path: '/model-runtime',
            component: () =>
                import('@/modules/model-runtime/components/Landing'),
            name: 'mr_landing'
        },
        {
            path: '/model-runtime/:domain/',
            component: () => import('@/modules/model-runtime/components/Home'),
            name: 'mr_home',
            children: [
                {
                    path: 'jobs',
                    component: () => import('@/modules/model-runtime/components/Jobs'),
                    name: 'mr_jobs',
                },
                {
                    path: 'jobs/new',
                    component: () => import('@/modules/model-runtime/components/Jobs'),
                    name: 'mr_jobs_new',
                },
                {
                    path: 'jobs/:jobId',
                    component: () =>
                        import('@/modules/model-runtime/components/JobDetails'),
                    name: 'mr_job_details'
                },
                {
                    path: 'jobs/:jobId/logs',
                    component: () =>
                        import('@/modules/model-runtime/components/LogViewer'),
                    name: 'mr_job_logs'
                },
                {
                    path: 'models',
                    component: () =>
                        import('@/modules/model-runtime/components/Models'),
                    name: 'mr_models'
                },
                {
                    path: 'scripts',
                    component: () =>
                        import('@/modules/model-runtime/components/Models'),
                    name: 'mr_scripts',
                    meta: {runtime: 'python3.6'}
                },
                {
                    path: 'fmus',
                    component: () =>
                        import('@/modules/model-runtime/components/Models'),
                    name: 'mr_fmus',
                    meta: {runtime: 'FMU'}
                },
                {
                    path: 'workflows',
                    component: () =>
                        import('@/modules/model-runtime/components/Workflows'),
                    name: 'mr_workflows'
                },
                {
                    path: 'workflows/new',
                    component: () =>
                        import('@/modules/model-runtime/components/Workflows'),
                    name: 'mr_workflows_new'
                },
                {
                    path: 'workflows/:jobId',
                    component: () =>
                        import('@/modules/model-runtime/components/JobDetails'),
                    name: 'mr_workflow_details'
                },
                {
                    path: 'workflows/:jobId/logs',
                    component: () =>
                        import('@/modules/model-runtime/components/LogViewer'),
                    name: 'mr_workflow_logs'
                }
            ]
        }
    ]
};



// WEBPACK FOOTER //
// ./src/modules/model-runtime/router.js